import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import type { PanelConfig } from '../types/panelConfig';

// apiClient already injects auth headers (X-Api-Key for demo, Bearer for
// real-firm panels via createBearerAuthClient interceptor). No manual header
// wiring needed here.
export function usePanelConfig() {
  return useQuery<PanelConfig>({
    queryKey: ['panelConfig'],
    queryFn: async () => {
      const { data } = await apiClient.get('/api/v2/panel/config');
      return data;
    },
    staleTime: 1000 * 60 * 10,
    retry: 2,
  });
}
